import { ROUTE_IDS } from '../../experience/routes/ids.js';
/** Shared persona access-profile building blocks. */
/**
 * The avatar menu exposes destinations, not every settings sub-route.
 * "Profile & preferences" and "Security" are the two consolidated destinations.
 * Security is a dedicated overview route that exposes Password, MFA and Sessions
 * as resolved children — the avatar targets Security, not Password directly, so
 * SSO users (no local password) still reach MFA and session management.
 */
export const COMMON_AVATAR_ROUTE_IDS = [
    ROUTE_IDS.SETTINGS_PROFILE,
    ROUTE_IDS.SETTINGS_SECURITY,
];
export const CLIENT_AVATAR_ROUTE_IDS = COMMON_AVATAR_ROUTE_IDS;
export const PLATFORM_ROOT_ADMIN_BASELINE_MODULES = [
    'PLATFORM',
    'AUTH',
    'DASHBOARD',
    'SETTINGS',
    'NAVIGATION',
    'ADMIN',
    'DATA',
    'REPORTING',
    'INSTRUMENTS',
    'MARKET_DATA',
];
export const PLATFORM_ROOT_ADMIN_FORBIDDEN_MODULES = [
    'INVESTMENT',
    'ACCOUNTING',
    'TAX',
    'RECONCILIATION',
    'CORPORATE_ACTIONS',
    'IMPORT',
    'FACTS',
    'HOLDINGS',
    'MARGIN_TRADING',
    'ORDER_MANAGEMENT',
];
export const ORG_USER_CLIENT_BASELINE_MODULES = [
    'AUTH',
    'DASHBOARD',
    'SETTINGS',
    'NAVIGATION',
    'INVESTMENT',
    'REPORTING',
];
/**
 * Platform personas operate on platform metadata only. Organization business
 * data requires a delegated organization context and is never reachable through
 * the normal platform shell, including legacy /admin aliases.
 */
export const PLATFORM_ROOT_ADMIN_DENIED_ROUTE_IDS = [
    ROUTE_IDS.TRANSACTIONS,
    ROUTE_IDS.TRANSACTION_CREATE,
    ROUTE_IDS.TRANSACTION_DETAIL,
    ROUTE_IDS.TRANSACTION_APPROVALS,
    ROUTE_IDS.TRANSACTION_REVERSALS,
    ROUTE_IDS.HOLDINGS,
    ROUTE_IDS.RECONCILIATION,
    ROUTE_IDS.CORPORATE_ACTIONS,
    ROUTE_IDS.DATA_IMPORTS,
    ROUTE_IDS.DATA_IMPORT_DETAIL,
    ROUTE_IDS.DATA_RECONCILIATION,
    ROUTE_IDS.DATA_RECONCILIATION_DETAIL,
    ROUTE_IDS.DATA_CORPORATE_ACTIONS,
    ROUTE_IDS.DATA_CORPORATE_ACTION_DETAIL,
    ROUTE_IDS.DATA_HOLDINGS,
    ROUTE_IDS.DATA_FACT_BATCHES,
    ROUTE_IDS.DATA_FACT_BATCH_DETAIL,
    ROUTE_IDS.USERS,
    ROUTE_IDS.USERS_CREATE,
    ROUTE_IDS.USERS_DETAIL,
    ROUTE_IDS.USERS_EDIT,
    ROUTE_IDS.ROLES,
    ROUTE_IDS.ROLES_CREATE,
    ROUTE_IDS.ROLES_DETAIL,
    ROUTE_IDS.ROLES_EDIT,
    ROUTE_IDS.AUDIT_EXPLORER,
    ROUTE_IDS.ORGANIZATION_ADMIN_HUB,
    ROUTE_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE,
    ROUTE_IDS.ORGANIZATION_USERS_LIST,
    ROUTE_IDS.ORGANIZATION_USERS_CREATE,
    ROUTE_IDS.ORGANIZATION_USERS_DETAIL,
    ROUTE_IDS.ORGANIZATION_USERS_EDIT,
    ROUTE_IDS.ORGANIZATION_ROLES_LIST,
    ROUTE_IDS.ORGANIZATION_ROLES_CREATE,
    ROUTE_IDS.ORGANIZATION_ROLES_DETAIL,
    ROUTE_IDS.ORGANIZATION_ROLES_EDIT,
    ROUTE_IDS.ORGANIZATION_PROFILE,
    ROUTE_IDS.ORGANIZATION_PROFILE_DETAIL,
    ROUTE_IDS.ORGANIZATION_BRANCHES_LIST,
    ROUTE_IDS.ORGANIZATION_BRANCHES_CREATE,
    ROUTE_IDS.ORGANIZATION_BRANCHES_DETAIL,
    ROUTE_IDS.ORGANIZATION_BRANCHES_EDIT,
    ROUTE_IDS.ORGANIZATION_MODULES_LIST,
    ROUTE_IDS.ORGANIZATION_MODULES_CONFIGURE,
    ROUTE_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST,
    ROUTE_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_EDIT,
    ROUTE_IDS.ORGANIZATION_CLIENTS_LIST,
    ROUTE_IDS.ORGANIZATION_CLIENTS_CREATE,
    ROUTE_IDS.ORGANIZATION_CLIENTS_DETAIL,
    ROUTE_IDS.ORGANIZATION_CLIENTS_EDIT,
    ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_LIST,
    ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_CREATE,
    ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_DETAIL,
    ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_EDIT,
    ROUTE_IDS.ORGANIZATION_PORTFOLIOS_LIST,
    ROUTE_IDS.ORGANIZATION_PORTFOLIOS_CREATE,
    ROUTE_IDS.ORGANIZATION_PORTFOLIOS_DETAIL,
    ROUTE_IDS.ORGANIZATION_PORTFOLIOS_EDIT,
    ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
    ROUTE_IDS.ORGANIZATION_AUDIT_DETAIL,
    ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
    ROUTE_IDS.ORGANIZATION_APPROVAL_POLICIES_LIST,
    ROUTE_IDS.ORGANIZATION_APPROVAL_POLICIES_DETAIL,
    ROUTE_IDS.ORGANIZATION_PERMISSION_BUNDLES_LIST,
    ROUTE_IDS.ORGANIZATION_PERMISSION_BUNDLES_DETAIL,
    ROUTE_IDS.ORGANIZATION_RETENTION_POLICIES,
    ROUTE_IDS.ORGANIZATION_EXPORT_POLICIES,
    ROUTE_IDS.ORGANIZATION_SECURITY_SETTINGS,
    ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE,
    ROUTE_IDS.ORGANIZATION_JURISDICTION_SETTINGS,
    ROUTE_IDS.ORGANIZATION_SUPPORT_ACCESS,
    ROUTE_IDS.DATA_CLIENTS,
    ROUTE_IDS.DATA_CLIENT_DETAIL,
    ROUTE_IDS.DATA_PORTFOLIOS,
    ROUTE_IDS.DATA_PORTFOLIO_DETAIL,
    ROUTE_IDS.DATA_MANDATES,
    ROUTE_IDS.DATA_POSITIONS,
    ROUTE_IDS.DATA_CASH,
    ROUTE_IDS.DATA_PERFORMANCE,
    ROUTE_IDS.DATA_SETTLEMENT_INSTRUCTIONS,
    ROUTE_IDS.DATA_CUSTODY_BALANCES,
    ROUTE_IDS.DATA_SETTLEMENT_FAILURES,
    ROUTE_IDS.DATA_POSITION_TRANSFERS,
    ROUTE_IDS.DATA_JOURNALS,
    ROUTE_IDS.DATA_JOURNAL_DETAIL,
    ROUTE_IDS.DATA_CHART_OF_ACCOUNTS,
    ROUTE_IDS.DATA_FISCAL_PERIODS,
    ROUTE_IDS.DATA_COMPLIANCE_BREACHES,
    ROUTE_IDS.DATA_RISK_EXPOSURES,
    ROUTE_IDS.DATA_TAX_RECORDS,
    ROUTE_IDS.DATA_TAX_CALCULATIONS,
    ROUTE_IDS.DATA_EVIDENCE,
    ROUTE_IDS.DATA_EVIDENCE_DETAIL,
];
